import {
  AiEnhancementOptions,
  EEnhancementImageType,
  EnhancementImageResponse
} from 'models/product'

/**
 * Парсит параметры поиска URL в объект настроек улучшения AI
 * @param searchParams - объект URLSearchParams
 * @returns объект AiEnhancementOptions с распарсенными параметрами
 */
export const parseEnhancementOptions = (
  searchParams: URLSearchParams
): AiEnhancementOptions => {
  const enhancementOptions: AiEnhancementOptions = {} as AiEnhancementOptions

  if (searchParams.get('productName')) {
    enhancementOptions.productName = searchParams.get('productName') as string
  }

  if (searchParams.get('improveDescription') === 'true') {
    enhancementOptions.improveDescription = true
  }

  if (searchParams.get('characteristics') === 'true') {
    enhancementOptions.characteristics = true
  }

  if (searchParams.get('productImage') === 'true') {
    enhancementOptions.productImage = true
  }

  if (searchParams.get('imageEnhancementType')) {
    enhancementOptions.imageEnhancementType = searchParams.get(
      'imageEnhancementType'
    ) as EEnhancementImageType
  }

  if (searchParams.get('improveDescriptionPrompt')) {
    enhancementOptions.improveDescriptionPrompt = searchParams.get(
      'improveDescriptionPrompt'
    ) as string
  }

  if (searchParams.get('fullEnhancementImagePrompt')) {
    enhancementOptions.fullEnhancementImagePrompt = searchParams.get(
      'fullEnhancementImagePrompt'
    ) as string
  }

  if (searchParams.get('initialImages')) {
    enhancementOptions.initialImages = searchParams
      .get('initialImages')
      ?.split(',')
      .map((image) => ({ image })) as EnhancementImageResponse[]
  }

  if (searchParams.get('selectedInitialImage')) {
    const data = searchParams.get('selectedInitialImage') as string
    enhancementOptions.selectedInitialImage = {
      image: data
    } as EnhancementImageResponse
  }

  return enhancementOptions
}
